<template>
  <div>
    <v-container>
      <v-row
        v-if="rectangle"
      >
        <report-list-item-rectangle
          v-for="(r,i) in reports" 
          :key="r.reportID" 
          :report-data="r"
          :contained-by="containedBy"
          :is-searching="isSearching"
          :id="'reportlistitem' + i"
          :search-props="searchProps"
          :search-items="searchItems"
        />
      </v-row>
      <v-row 
        v-else
      >
        <report-list-item
          v-for="(r,i) in reports" 
          :key="r.reportID" 
          :report-data="r"
          :contained-by="containedBy"
          :is-searching="isSearching"
          :id="'reportlistitem' + i"
          :search-props="searchProps"
          :search-items="searchItems"
          :hide-favorite-icon="hideFavoriteIcon"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ReportListItemRectangle from './report-list-item-rectangle.vue'
import ReportListItem from './report-list-item.vue'

export default {
  name: 'report-list',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  props: {
    'reports': {
      type: Array,
      default () {
        return []
      }
    },
    'isSearching': {
      type: Boolean,
      default () {
        return false
      }
    },
    'containedBy': {
      type: Object,
      default () {
        return {}
      }
    },
    'searchProps': {
      type: Object,
      default () {
        return { searchCriteria: '' }
      }
    },
    'searchItems': {
      type: Function,
      default () {
        return () => { alert('Err func') }
      }
    },
    'rectangle': {
      type: Boolean,
      default () {
        return false
      }
    },
    'hideFavoriteIcon': {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  components: {
    ReportListItem,
    ReportListItemRectangle
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/report-list.vue